
import styled from 'styled-components';
import React from 'react';
import ActionsContext from '../ActionsContextV2';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import FormControl from '@material-ui/core/FormControl';

const Container = styled.div`
    padding-left:20px;
    width:200px;
    border-color:red;
`;

const useStyles = makeStyles((theme) => ({
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
        background:'white'
    },
}));

const customStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "rgb(61, 122, 150);" : null,
    boxShadow: 'none',
    border: state.isFocused  ? '1.5px solid lightgray' : '1px solid lightgray', // default border color
    "&:hover": {
      borderColor: state.isFocused ? "rgb(61, 122, 150);" : "black"
    }
  }),
  menu: base => ({
    ...base,
    borderRadius: 0,
    marginTop: 0
  }),
  menuList: base => ({
    ...base,
    padding: 0,
    maxHeight : window.innerHeight - 300
  })
};

const ActionFormCategoryFilterV2 = () => {
  const classes = useStyles();
  const context = React.useContext(ActionsContext);

  let {pendingActions,approvedActions,currentStepIndex = 0} = context.actionsRedux.selectedProjectFunctionDetails;
  // if compliance filter exists then apply that
  if (context.complianceFilterText !== "" && context.complianceFilterText !== "All") {
    pendingActions = pendingActions.filter((pa) => { return  (pa.applicability && pa.applicability === context.complianceFilterText)});
    approvedActions = approvedActions.filter((aa) => { return  (aa.applicability && aa.applicability === context.complianceFilterText)});
  }

  let actions = context.pendingCompletedTab === 0 ? pendingActions : approvedActions;
  const actionsWithAllOption = [{categoryName: 'All'}].concat(actions);
  
  // find unique categories
  let uniqueCategoryList = [...new Set( actionsWithAllOption.map(obj => obj.categoryName)) ];

  // filter the count for each unique category and current step in workflow to display next to it
  let filteredCategories = [];
  uniqueCategoryList.forEach(function (cat, index) {
    filteredCategories = context.pendingCompletedTab === 0 ? pendingActions.filter((pa) => { return  (pa.categoryName === cat && pa.currentStepIndex === currentStepIndex);}) :
      approvedActions.filter((pa) => { return  (pa.categoryName === cat);});

    uniqueCategoryList[index] = (cat === 'All') ? cat : cat + ' (' + filteredCategories.length + ')';
  });
  
  const buildCategoryData = category => {
    return { label: category, value : category }
  }

  uniqueCategoryList = uniqueCategoryList.map(buildCategoryData);
  let categoryList = [
    {
        label:"Categories",
        options:uniqueCategoryList
    },
  ]

  return <Container>
    <Select
      // value = {context.categoryFilterText}
      classes={classes}
      styles={customStyles}
      options={categoryList}
      onChange={(selectedCategeory) => {
        const category = selectedCategeory.value.substring(0, selectedCategeory.value.indexOf( ' (' ));
        context.setCategoryFilterText(category);
        context.showSnackBarMessage("Filter Successfully Applied.",null,4000);
      }}
      placeholder="Category"
      
    />
  </Container>
}

export default  ActionFormCategoryFilterV2;